import { Stack } from '@chakra-ui/react';
import { theme } from '@chakra-ui/theme';
import { Box, Grid, Text } from '@chakra-ui/react';
import DocumentCard from '../components/DocumentCard';
import { useAppSelector } from '../lib/hooks';
import { useLocation } from 'react-router-dom';
import FilterNodes from '@/lib/SearchFilter';
import { useLazyGetNodeQuery } from '@/lib/api/GraphAPI';
import { useEffect, useState } from 'react';
import { Node } from '@/lib/api/APITypes';

export function FolderPage() {
  const location = useLocation();
  const folder_id_in_path = location.pathname.split('/saved_cases/')[1];
  const current_folder = useAppSelector(
    (state) => state.viewReducer.documents.structure.FOLDER[folder_id_in_path],
  );
  const filter = useAppSelector((state) => state.viewReducer.documents.filter);
  const [nodeQuery] = useLazyGetNodeQuery();
  const [nodes, setNodes] = useState<Node[]>([]);
  const [filteredNodes, setFilteredNodes] = useState<Node[]>([]);

  const node_search_query = useAppSelector(
    (state) => state.viewReducer.documents.search.query.DOCUMENT,
  );

  useEffect(() => {
    if (!current_folder) return;

    const fetchNodes = async () => {
      try {
        const results = await Promise.all(
          current_folder.documents.map((doc) => nodeQuery(doc).unwrap()),
        );
        setNodes(results);
      } catch (err) {
        console.error('Error fetching nodes:', err);
        setNodes([]); // so UI can handle failures gracefully
      }
    };

    fetchNodes();
  }, [current_folder?.documents, nodeQuery]);

  useEffect(() => {
    if (current_folder && current_folder.documents.length === nodes.length) {
      setFilteredNodes(FilterNodes('DOCUMENT', node_search_query, nodes, filter));
    }
  }, [nodes, filter, node_search_query, setFilteredNodes]);
  return (
    <Box backgroundColor="background" p={2} height={'100%'}>
      <Stack height={'100%'}>
        <Text color="secondaryText" fontWeight={700} fontSize={'xx-large'} p={2}>
          Folder: {current_folder?.name}
        </Text>
        <Grid
          background="midCardBG"
          padding={4}
          style={{
            height: '100%',
            borderRadius: '10px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            justifyItems: 'center',
          }}
          templateColumns={'repeat(auto-fit, minmax(380px, 1fr))'}
          gap={4}
        >
          {filteredNodes.map((node) => (
            <DocumentCard key={'page' + current_folder?.id + node.id} id={node.id} />
          ))}
        </Grid>
      </Stack>
    </Box>
  );
}
